module.exports = __webpack_public_path__ + "img/przelew_na_telefon.65409e39.png";